/*
 * Copyright © 2018 Aram Meem Company Limited.  All Rights Reserved.
 */

export class PointOnMap {
  lat: number = null;
  lon: number = null;

}



// WEBPACK FOOTER //
// ./src/app/models/point-on-map.ts